<template>
  <div>
    <div v-if="loader">
      <Loader />
    </div>

    <div v-else class="tw-mx-4 tw-mt-4">
      <div class="card row tw-border-0">
        <div class="tw-flex tw-justify-start tw-items-center mr-2" id="summary-filters">
          <div class="mr-2">
            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
              Date
            </div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              @update="formateDate"
              :min-date="minDate"
              :max-date="maxDate"
            >
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
              Channel
            </div>
            <multiselect
              @input="handlePlatformSelection"
              v-model="selectedChannel"
              class="text-capitalize"
              :options="channelList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="selectedChannel?.length == channelList?.length ? 1 : 100"
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedChannel"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.value.replaceAll("_", " ") }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
              Brand
            </div>
            <multiselect
              v-model="selectedBrand"
              class="text-capitalize"
              :options="brandList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Brand"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="selectedBrand?.length == brandList?.length ? 1 : 100"
              @input="handleBrand"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedBrand"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <!-- <template #singleLabel="{ option }">
                                {{ option.displayname.replaceAll("_", " ") }}
                                </template> -->
            </multiselect>
          </div>
          <button class="btn primarycolor pt-[0px] tw-mt-6" @click="dataAPIs">
            Apply Filters
          </button>
        </div>
      </div>
      <div
        class="card row tw-border-0 w-border-0 summaryContainer tw-mb-0 row tw-z-[10]"
      >
        <div
          class="tw-flex tw-justify-between tw-border-b-[1px] tw-pb-2 tw-mb-4 tw-border-[#D4D4D4]"
        >
          <div class="tw-flex tw-justify-between">
            <span
              class="tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2"
              >Rating Count - Brand</span
            >
          </div>
          <button
            class="ui button exportButton ml-1"
            @click="exportAPICall('brand')"
          >
            <svg
              v-if="isRatingDownload"
              aria-hidden="true"
              role="status"
              class="tw-inline tw-w-4 tw-h-4 tw-mr-1 tw-text-white tw-animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              />
            </svg>
            {{ isRatingDownload ? "Exporting..." : "Export" }}
          </button>
        </div>
        <div class="tw-w-full">
          <div class="tw-w-full" v-if="Object.keys(viewRattingCountData).length" >
            <table id="rattingDataTable" class="tw-w-full">
              <thead class="thead-normal">
                <tr>
                  <th rowspan="2">Brand</th>
                  <th
                    :colspan="header.subData"
                    v-for="header in viewRattingCountData.header"
                    v-if="header.key !== 'brand'"
                    :key="header.key"
                  >
                    {{ header.value }}
                  </th>
                </tr>
                <tr>
                  <template
                    v-for="header in viewRattingCountData.header"
                    v-if="header.key !== 'brand'"
                  >
                    <th
                      v-for="star in [
                        { key: '1 star', value: '1' },
                        { key: '2 star', value: '2' },
                        { key: '3 star', value: '3' },
                        { key: '4 star', value: '4' },
                        { key: '5 star', value: '5' },
                      ]"
                      :key="header.key"
                    >
                      <div
                        class="tw-flex tw-items-center tw-gap-2 tw-justify-center"
                      >
                        {{ star.value
                        }}<img src="Icons_SVG/rating_star.svg" alt="star" />
                      </div>
                    </th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, rowIndex) in viewRattingCountData.data"
                  :key="row.brand + '|' + rowIndex"
                  class="tw-border tw-border-[#d4d4d4] tw-capitalize"
                >
                  <td>{{ row.brand }}</td>
                  <template
                    v-for="header in viewRattingCountData.header"
                    v-if="header.key !== 'brand'"
                  >
                    <td
                      v-for="star in [
                        '1 star',
                        '2 star',
                        '3 star',
                        '4 star',
                        '5 star',
                      ]"
                      :key="header.key + '-' + star"
                    >
                      {{
                        row[header.key] && row[header.key][star]
                          ? row[header.key][star]
                          : 0
                      }}
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="tw-min-h-[400px]">
            <noData :loaderVariable="ratingCountLoader || !ratingCountLoaded" />
          </div>
        </div>
      </div>
      <!-- net sales breakup graph section  -->
      <div class="card tw-border-0 summaryContainer tw-mb-0 row tw-z-[12]">
        <div class="tw-mb-0">
          <div
            class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]"
          >
            <span
              class="tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2"
              >Rating of Reviews</span
            >
          </div>
          <div v-if="proccedRattingStackChartData" class="!tw-w-[100%]">
            <stackChart :rawData="proccedRattingStackChartData" :height="450" />
          </div>
          <div class="" v-else>
            <noData :loaderVariable="stackChartLoader" />
          </div>
        </div>
      </div>
      <div
        class="card row tw-border-0 w-border-0 summaryContainer tw-mb-0 row tw-z-[10]"
      >
        <div
          class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]"
        >
          <span
            class="tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2"
            >Reviewer Details</span
          >
          <button
            class="ui button exportButton ml-1"
            @click="exportAPICall('review')"
          >
            <svg
              v-if="isReviewDownload"
              aria-hidden="true"
              role="status"
              class="tw-inline tw-w-4 tw-h-4 tw-mr-1 tw-text-white tw-animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              />
            </svg>
            {{ isReviewDownload ? "Exporting..." : "Export" }}
          </button>
        </div>
        <div>
          <div class="" v-if="Object.keys(viewReviewDetailsData).length">
            <table id="reviewerDetails" class="tw-w-full">
              <thead class="thead-normal">
                <tr>
                  <th :rowspan="2" class="tw-max-w-[200px]">Reviewer Name</th>
                  <th
                    :colspan="header.subData"
                    v-for="header in viewReviewDetailsData.header"
                    v-if="header.key !== 'reviewer'"
                    :key="header.key"
                  >
                    {{ header.value }}
                  </th>
                </tr>
                <tr>
                  <!-- <th class="tw-bg-![#fff] !tw-p-0"></th> -->
                  <template
                    v-for="header in viewReviewDetailsData.header"
                    v-if="header.key !== 'reviewer'"
                  >
                    <th
                      v-for="star in [
                        { key: '+ve', value: '+ve' },
                        { key: '-ve', value: '-ve' },
                      ]"
                      :key="header.key"
                      class="tw-bg-![#fff]"
                    >
                      <div
                        class="tw-flex tw-items-center tw-gap-2 tw-justify-center !tw-p-0"
                      >
                        {{ star.value }}
                      </div>
                    </th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, rowIndex) in viewReviewDetailsData.data"
                  :key="row.reviewer + '|' + rowIndex"
                  class="tw-border tw-border-[#d4d4d4] tw-capitalize"
                >
                  <td class="tw-max-w-[200px]">{{ row.reviewer }}</td>
                  <template
                    v-for="header in viewReviewDetailsData.header"
                    v-if="header.key !== 'reviewer'"
                  >
                    <td
                      v-for="star in ['+ve', '-ve']"
                      :key="header.key + '-' + star"
                    >
                      {{
                        row[header.key] && row[header.key][star]
                          ? row[header.key][star]
                          : 0
                      }}
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="tw-min-h-[400px]">
            <noData :loaderVariable="reviewDetailsLoader || !reviewDetailsLoaded" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Loader from "../Components/Loader.vue";
import stackChart from "../commonCharts/StackChart.vue";
import noData from "../Components/noData.vue";
export default {
  name: "summary",
  components: { Datepicker, Multiselect, Loader, stackChart, noData },
  data: function () {
    return {
      dateRange: {
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      // Loader Section start
      loader: false,
      stackChartLoader: false,
      reviewDetailsLoader: false,
      ratingCountLoader: false,
      ratingCountLoaded: false,
      reviewDetailsLoaded: false,
      // Loader Section End
      // filter section
      selectedChannel: [],
      previousSelection: [],
      channelList: [],
      selectedBrand: [],
      brandList: [],
      previousBrandSelection: [],
      viewRattingCountData: {},
      viewReviewDetailsData: {},
      viewRattingOfReviewsStackChartData: {},
      proccedRattingStackChartData: {},
      isRatingDownload: false,
      isReviewDownload: false,
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Reviews_And_Ratings,

    };
  },
  mounted() {
    this.getLastUpdatedDates();
    this.$store.dispatch("DemoStore/setTimeStamp", ""); //using for clear the last updated time stamp
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");
  },

  methods: {
    dataAPIs() {
      if ($.fn.DataTable.isDataTable("#reviewerDetails")) {
        $("#reviewerDetails").DataTable().destroy();
      }
      if ($.fn.DataTable.isDataTable("#rattingDataTable")) {
        $("#rattingDataTable").DataTable().destroy();
      }
      this.getRattingCount();
      this.getReviewDetails();
      this.getRattingCountStackChart();
    },

    formateDate() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.dateRange.endDate = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );
      // this.dataAPIs();
    },
    getLastUpdatedDates() {
      this.loader = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http
        .get(url)
        .then((response) => {
          localStorage.sentiments_last_update = JSON.stringify(
            response.body.data?.sentiments
          );
          this.dateRange.endDate = moment(
              response.body.data.reviews_and_ratings?.end_date
          ).format("YYYY-MM-DD");

          this.dateRange.startDate = moment(
              response.body.data.reviews_and_ratings?.end_date
          ).subtract(1,'month').format("YYYY-MM-DD");
          this.maxDate= response.body.data.reviews_and_ratings?.end_date
          this.minDate= response.body.data.reviews_and_ratings?.start_date

          // this.maxDateTableDateRange = new Date(
          //     response.body.data.sentiments?.end_date
          // );
          // this.$store.dispatch("DemoStore/setTimeStamp", "");

          this.getFilterData(true);
        })
        .catch((err) => {
          this.loader = false;
          // this.getBrandDetails();
          console.log("err", err);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    formatNumber(num) {
      if (isNaN(num)) return num;
      let num1 = Number(num).toFixed(2);
      let num2 = Number(num1).toLocaleString();
      return num2;
    },
    handlePlatformSelection(selected) {
      const otherOptions = this.channelList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedChannel = [...this.channelList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedChannel = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedChannel = [...this.channelList];
        } else {
          this.selectedChannel = [...selectedWithoutAll];
        }
      }
      this.previousSelection = [...this.selectedChannel];
      this.getBrandData(false);
    },
    handleBrand(selected) {
      const otherOptions = this.brandList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousBrandSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedBrand = [...this.brandList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedBrand = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedBrand = [...this.brandList];
        } else {
          this.selectedBrand = [...selectedWithoutAll];
        }
      }

      this.previousBrandSelection = [...this.selectedBrand];
    },
    getFilterData(isMounted) {
      this.loader = true;
      const url = "/api/v2/product/filter_data";
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        feature_id: this.featureId,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          this.channelList = response.data.data.platform;
          if (this.channelList.length) {
            this.channelList.unshift({ key: "All", value: "All" });
          }
          this.selectedChannel = [...this.channelList];
          this.previousSelection = [...this.selectedChannel];
          this.loader = false;
          this.getBrandData(isMounted);
        })
        .catch((error) => {
          console.error("Error fetching filter data:", error);
          this.loader = false;
        });
    },

    getBrandData(isMounted) {
      // this.loader = true;
      const url = "/api/v2/brand/data";
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        language: "en",
        channel: this.selectedChannel
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: [],
        product: [],
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          this.brandList = response.data.data;
          if (this.brandList.length) {
            this.brandList.unshift({ key: "All", value: "All" });
          }
          this.$nextTick(() => {
            this.selectedBrand = [...this.brandList];
            this.previousBrandSelection = [...this.selectedBrand];
          });
          if (isMounted) {
            this.dataAPIs();
          }
          // this.loader = false;
        })
        .catch((error) => {
          console.error("Error fetching filter data:", error);
          // this.loader = false;
        });
    },
    exportAPICall(tab) {
      if (tab === "brand") {
        this.isRatingDownload = true;
      } else if (tab == "review") {
        this.isReviewDownload = true;
      }
      const url = "/api/v2/reviews/sheet";
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        channel: this.selectedChannel
          .filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        brand: this.selectedBrand
          .filter((brand) => brand.key !== "All")
          .map((brand) => brand.key),
        category: [],
        price_range: [],
        product: [],
        is_sku: true,
        filter_type: tab,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          window.location = response.data.data?.file_url;
          this.isRatingDownload = false;
          this.isReviewDownload = false;
        })
        .catch((error) => {
          this.isRatingDownload = false;
          this.isReviewDownload = false;
          console.error("Error exporting data:", error);
        });
    },
    getRattingCount() {
      this.ratingCountLoader = true;
      this.ratingCountLoaded = false;
      this.viewRattingCountData = {};
      const url = "/api/v2/boat/rating_count";
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        channel: this.selectedChannel
          .filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        brand: this.selectedBrand
          .filter((brand) => brand.key !== "All")
          .map((brand) => brand.key),
        category: [],
        product: [],
        filter_type: "brand",
        language: "en",
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          this.viewRattingCountData = response.data;
          this.$nextTick(() => {
            this.processTable("#rattingDataTable");
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          this.ratingCountLoader = false;
          this.ratingCountLoaded = true;
        });
    },

    getRattingCountStackChart() {
      this.stackChartLoader = true;
      this.viewRattingOfReviewsStackChartData = {};
      this.proccedRattingStackChartData = "";
      const url = "/api/v2/boat/rating_count_new";
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        channel: this.selectedChannel
          .filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        brand: this.selectedBrand
          .filter((brand) => brand.key !== "All")
          .map((brand) => brand.key),
        category: [],
        product: [],
        filter_type: "brand",
        language: "en",
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          this.viewRattingOfReviewsStackChartData = response.data;
          this.proccedRattingStackChartData = this.processStackChart(
            this.viewRattingOfReviewsStackChartData?.data,
            "Ratting of Reviews"
          );
          this.stackChartLoader = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.stackChartLoader = false;
        });
    },

    getReviewDetails() {
      // this.loader = true;
      this.reviewDetailsLoader = true;
      this.reviewDetailsLoaded = false;
      this.viewReviewDetailsData = {};
      const url = "/api/v2/boat/review_detail";
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        channel: this.selectedChannel
          .filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        brand: this.selectedBrand
          .filter((brand) => brand.key !== "All")
          .map((brand) => brand.key),
        language: "en",
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          this.viewReviewDetailsData = response.data;
          this.$nextTick(() => {
            this.processTable("#reviewerDetails");
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          // this.loader = false;
          this.reviewDetailsLoader = false;
          this.reviewDetailsLoaded = true;
        });
    },

    exportOrdersBreakupData(tab) {
      if (tab === "All") {
        this.isAllDownload = true;
      } else {
        this.isTabWiseExporting = true;
      }
      const url = "/api/unicommerce/orders_table/";
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        level: tab,
        export: true,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          window.location = response.data.data?.file_url;
          this.isTabWiseExporting = false;
          this.isAllDownload = false;
        })
        .catch((error) => {
          this.isTabWiseExporting = false;
          this.isAllDownload = false;
          console.error("Error exporting data:", error);
        });
    },

    processStackChart(data, name) {
      const tempKey = Object.keys(data[0]).filter(
        (datakey) => datakey != "rating"
      );
      let temp = {
        categories: data.map((rating) => rating.rating),
        seriesData: [],
      };
      let tempSeries = { name: "", data: [] };
      tempKey.forEach((key) => {
        tempSeries = { name: "", data: [] };
        data.forEach((data) => {
          (tempSeries.name = key), tempSeries.data.push(data[key]);
        });
        temp.seriesData.push(tempSeries);
      });
      return temp;
    },

    processTable(id) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        ordering: true,
        order: [],
        columnDefs: [
          {
            targets: 0,
            className: "min-width-column",
          },
        ],
        initComplete: function () {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });
      $(id + "_filter > label").append(
        `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
      );
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.card {
  margin-bottom: 1rem !important;
}

.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}

.tab-label {
  cursor: pointer;
  padding-bottom: 12px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
}

.tab-label.active {
  color: rgba(6, 85, 89, 1);
  border-bottom: 1px solid rgba(6, 85, 89, 1);
  font-weight: 600 !important;
}

.stepper-container {
  padding: 20px;
  font-family: sans-serif;
}

.steps {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.step {
  font-weight: 600;
  color: #999;
}

.step.active {
  color: #065559;
  font-weight: bold;
}

.step-circle.active {
  background-color: #065559;
  color: white;
  padding: 10px;
  border-radius: 50%;
}

.line {
  flex-grow: 1;
  height: 2px;
  background-color: #ccc;
  margin: 0 10px;
}

.input-box {
  width: 100%;
  padding: 10px;
  border: 1px solid #aeaeae;
  border-radius: 5px;
  margin-bottom: 16px;
}

.suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.sku-pill {
  border: 1px solid #aeaeae;
  border-radius: 20px;
  padding: 6px 12px;
  background: white;
  cursor: pointer;
}

.button-group {
  text-align: right;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
</style>
<style>
#werehouseDateRange .multiselect__tags {
  border: 1px solid #ccc !important;
  max-height: 20px !important;
}

#werehouseDateRange .reportrange-text {
  height: 34px !important;
  width: 180px !important;
}

#werehouseDateRange .reportrange-text span {
  font-size: 16px !important;
}

.borderBetweenTab {
  border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
  margin-bottom: 15px !important;
}
#summary-filters .multiselect__strong {
  display: none !important;
}
</style>
